window.addEventListener("load", function(){
    try{
        const faq = document.querySelector(".faq__content");
        if(faq){
          const sections = faq.querySelectorAll('section[tabindex="0"]');
          sections.forEach((section)=>{
            section.removeAttribute("tabindex");
          });
        }
    } catch(e){
      //console.log(e);
    }
});

document.addEventListener("DOMContentLoaded", function() {

  try{
    //#28
    function fixPopup(){
      if(document.querySelectorAll("form.needsclick").length > 0){
        document.querySelectorAll("form.needsclick").forEach((form, formIndex)=>{
          form.querySelectorAll("input").forEach((input, inputIndex)=>{
            let inputID = '';
            if(input.getAttribute("ID")){
              inputID = input.getAttribute("ID");
            } else {
              inputID = 'ada-form-'+formIndex+'-'+inputIndex;
              input.setAttribute("id", inputID);
            }
            let label = document.createElement("label");
            label.innerText = input.placeholder;
            label.setAttribute("for", inputID);
            label.className = "sr-only";
            input.insertAdjacentElement("beforebegin", label);
          });
        
        });
      } else {
        setTimeout(()=>{
          fixPopup();
        }, 1000)
      }
    }
    fixPopup();
  } catch(e){
    //console.log(e)
  }

  try{
    // #64
    const targetNode = document.querySelector(".collection-toolbar__button-container > button");
    const config = { attributes: true, childList: false, subtree: false };
    const callback = (mutationList, observer) => {
      if(targetNode.getAttribute("aria-haspopup") !== "true"){
        setTimeout(()=>{
          targetNode.setAttribute("aria-haspopup", "true")
        }, 0)
      }
    };
    
    const observer = new MutationObserver(callback);
    
    observer.observe(targetNode, config);
  } catch(e){
    //console.log(e);
  }
  
  // 9.Empty "alt" attribute provided for informative image link
  let megamenu_alt_text = document.querySelectorAll('.mega-menu .mega-menu__promo');
  if(megamenu_alt_text){
  	for (i=0; i<megamenu_alt_text.length; i++){
  		let getText = megamenu_alt_text[i].querySelector('.v-stack p.h6');        
  		let setText = megamenu_alt_text[i].querySelector('a.v-stack img');
        let text = getText.textContent;
        setText.alt = text;
  	}
    
  }

  // 
  document.querySelector('.footer__inner .footer__block.footer__block--image a > img').alt = 'ADA Site Compliance-Accessibility Policy';

 //

    let ariaLabels = ['From price $', 'To price $', 'From price $', 'To price $'];
      document.querySelectorAll('.accordion-list .price-range .input-group input').forEach((input, index) => {
          if (index < ariaLabels.length) {
              input.setAttribute('aria-label', ariaLabels[index]);
          }
      });
  
  
  //

    var successBanner = document.querySelector('#contact_form .banner--success');
      if (successBanner) {
        successBanner.setAttribute('role', 'status');
        successBanner.setAttribute('aria-live', 'polite');
    }



  //

var firstLink = document.querySelector(".main-search__resource-item .blog-post-card a");
if (firstLink) {
    firstLink.setAttribute("aria-label", "Read more on 20 YEARS OF PILLOWS AND PILLOW TALK WITH THE PILLOW BUTLER® TEAM AT DOWN ETC");
} 

  //
    const currentPath = window.location.pathname;
      
      if (currentPath.endsWith('down-bed-pillows')) {      
      document.title = 'down and feather bed pillows | Down etc';
        } else if (currentPath.endsWith('contact')) {
            document.title = 'Contact | Down etc';
    } 
  
  //
  let local_lang_button = document.querySelectorAll('.shopify-localization-form .popover__value-list button, button.localization-toggle.heading.text-xxs.link-faded');
  if(local_lang_button){
    setTimeout(()=>{
        let j = 1;
        // let k = 2;
    	for (i=0; i<local_lang_button.length; i++){
          local_lang_button[i].querySelector('span').id = 'ex'+j;
          // local_lang_button[i].id = 'ex'+k;
// local_lang_button[i].setAttribute('aria-labelledby', 'ex'+j+' '+'ex'+k);
          local_lang_button[i].setAttribute('aria-labelledby', 'ex'+j);
          j+=1;
          // k+=2;
    	}        
    }, 100)
  }

  
  // 
  let slide = document.querySelector('.slideshow');
  if (slide) {    
    slide.role = 'region';
    slide.ariaLabel = 'Carousel';
    slide.ariaLive = 'polite';
  }
  

  // 
  let cartText = document.querySelector('.header__secondary-nav a[data-no-instant] span');
  if (cartText) {
    cartText.textContent = "Open cart, contains items";
  }

  
var Learn_more = document.querySelector('a[href="/pages/our-brand"][title="Our Brand"]');
if (Learn_more) {
    Learn_more.setAttribute('aria-label', 'Learn more about our values');
}

document.querySelectorAll("h2.h2").forEach(function(h2) {
    if (h2.textContent.includes("Frequently Asked Questions")) {
        var h1 = document.createElement("h1");
        h1.innerHTML = h2.innerHTML;
        h1.className = h2.className;
        h2.parentNode.replaceChild(h1, h2);
    }
});

  
  setTimeout(function() {
    var items = document.querySelectorAll("#insta-feed .instafeed-new-layout-item .instafeed-new-layout-item-container");
    items.forEach(function(item, index) {      
      item.setAttribute("aria-label", "Open Instagram post " + (index + 1)); 
      const child = item.querySelector(".instafeed-hover-layer");
      child.setAttribute("tabindex", "-1");
      child.removeAttribute("aria-label");
       
    });

    var sort_by_review = document.querySelector('select#kl_reviews__sort_by_reviews');
    if(sort_by_review){
       sort_by_review.setAttribute('title', 'Sort by rating');
    }
     var rating_number = document.querySelector('select#kl_reviews__filter_reviews_rating');
    if(rating_number){
       rating_number.setAttribute('title', 'Filter by rating number');
    }
 
    // 

    var popup = document.querySelector('.needsclick span.ql-font-century-gothic');

    if (popup) {
      var h2 = document.createElement('h2');   
      h2.innerHTML = popup.innerHTML;   
      
      popup.parentNode.replaceChild( h2, popup);
    }
    //
    document.querySelectorAll('.predictive-search__content .product-card').forEach(function(element) {
    element.setAttribute('role', 'tabpanel');
    }); 

    //
    document.querySelectorAll('.predictive-search__content button.h6').forEach(function(element) {
        element.setAttribute('role', 'tablist');
    });  
    
  }, 10000); 

   setTimeout(function() {

     // 
    let shippingAddress = document.querySelector("#checkout-main #shippingAddressForm button svg")
    if (shippingAddress) {
      shippingAddress.setAttribute('aria-label', 'More information on phone number');
    }
  
    // #75

     var paginationNav = document.querySelector('.section-stack nav.pagination');
        if (paginationNav) {
        paginationNav.removeAttribute('role');
        paginationNav.setAttribute("aria-label", "pagination");
        }  
     
    // 
    
    // const updateTitle = () => {
    // const originalTitle = document.title;
    // const url = window.location.href;
    // const urlObj = new URL(url);
    // const params = new URLSearchParams(urlObj.search);
    // const pageValue = params.get("page");
    // if (pageValue) {
    //     const titlePrefix = originalTitle.split(" | ")[0];
    //     const newTitle = `${titlePrefix}  | Down etc`;
    //     document.title = newTitle;
    //     }
    // };
    // updateTitle();

     var i = 1;
      document.querySelectorAll(".cart-drawer__items .line-item").forEach(function (lineItem) {
          var downCartItemAnchor = lineItem.querySelector(".down_cart_item a");
          var downRemoveLinkAnchor = lineItem.querySelector(".down_remove a.link");
          if (downCartItemAnchor) {
              downCartItemAnchor.id = "head" + i;
          }
          if (downRemoveLinkAnchor) {
              downRemoveLinkAnchor.id = "Update" + i;
              downRemoveLinkAnchor.setAttribute('aria-labelledby', 'Update' + i + ' ' + 'head' + i);
          }
          i++;
   });

  //   
    const button = document.querySelector('.cart-drawer__footer button.link-faded-reverse');
    if(button){
      const h3 = document.createElement('h3');
      h3.style.fontSize = '14px';
      h3.style.fontWeight = '500';
      button.parentNode.insertBefore(h3, button);
      h3.appendChild(button);

    }
      
  // 
      document.querySelector('.header__secondary-nav a[href="/search"]').addEventListener("click", function() {
        this.setAttribute("aria-expanded", "false");
        document.querySelector('.header__secondary-nav a[href="/search"]').setAttribute("aria-expanded", "true");
    });
      document.querySelector('.header__secondary-nav a[href="/search"]').setAttribute("aria-expanded", "false");
 //
     let images = document.querySelectorAll('img');
        images.forEach(function(image) {
    if (image.src.includes('HEXAGON_sheet_size_guide_2.png')) {
        image.setAttribute('alt', 'Sheet Size Guide');
        }
    });

     
  }, 2000); 

  document.querySelectorAll('.section-stack .blog-post-list a img').forEach(function(img) {
    img.setAttribute('alt','');
  });

  //  
  
    

  
  


  //document.querySelectorAll("#shopify-section-template--17112103616666__contact-form .prose h2").forEach(function(h2) {
  // aeye rewrite selector: ID issue
  document.querySelectorAll('section[id$="__contact-form"] .prose h2').forEach(function(h2) {
  const h1 = document.createElement("h1");
     h1.className = h2.className;
     h1.innerHTML = h2.innerHTML; 
     h2.parentNode.replaceChild(h1, h2);
  });

  // 
  let cartBtn = document.querySelector('.header__secondary-nav a[href="/cart"]');

  if (cartBtn) {
      cartBtn.addEventListener('click', function (e) {
          let cartItems = document.querySelectorAll('.cart-drawer__items .line-item');          
          let i = 1;
          let j = 1;
          let k = 1;        
          let x = 1;
          let y = 1;
          if (cartItems) {
              cartItems.forEach(function (e) {
                  let cartTitle = e.querySelectorAll('.line-item-info .cart-product-title');                
                  cartTitle.forEach(function (e) {
                      e.setAttribute('id', 'head'+i);
                      i+=1;
                  })
                
                  let cartQuan = e.querySelectorAll('.line-item-info quantity-input input');
                  cartQuan.forEach(function (e) {
                      e.setAttribute('id', 'qty'+j);
                      e.setAttribute('aria-labelledby', 'qty'+k+" "+'head'+k);
                      j+=1;
                      k+=1;
                  })

                  let cartRemove = e.querySelectorAll('line-item-quantity>a');
                  cartRemove.forEach(function (e) {
                      e.setAttribute('id', 'Update'+x);
                      e.setAttribute('aria-labelledby', 'Update'+x+" "+'head'+y);
                      x+=1;
                      y+=1;
                  })
              })
          }
      })
  }

  // 

 
// function updateAriaHaspopup(button) {
//         const ariaExpanded = button.getAttribute('aria-expanded');
//         // Set 'aria-haspopup' to 'true' if 'aria-expanded' is 'true', otherwise 'false'
//         button.setAttribute('aria-haspopup', ariaExpanded === 'true' ? 'true' : 'false');
//     }

//     // Initial update on page load
//     document.querySelectorAll('button.collection-toolbar__button').forEach(function(button) {
//         updateAriaHaspopup(button);
//     });

//     // Add click event listener to update 'aria-haspopup' on button click
//     document.querySelectorAll('button.collection-toolbar__button').forEach(function(button) {
//         button.addEventListener('click', function() {
//             // Directly update 'aria-haspopup' based on current 'aria-expanded'
//             updateAriaHaspopup(button);
//         });
//     });

  // 

  let contact_form = document.querySelector('#contact_form > div.fieldset');
  if (contact_form) {
      let divElement = document.createElement('div');
      let divContent = document.createTextNode('* denotes mandatory fields');
      divElement.appendChild(divContent);
      divElement.classList.add('contact-mandatory');
      divElement.style.color = 'red';
      contact_form.parentNode.insertBefore(divElement, contact_form);
      
      let contact_input = contact_form.querySelectorAll("input[required], textarea[required]");
      contact_input.forEach(function (e) {
          let labelText = e.getAttribute('placeholder');
          e.setAttribute("placeholder", labelText + "*");
      });
  }

         const labels = document.querySelectorAll('#contact_form .floating-label');
         const selectedLabels = [labels[0], labels[1],labels[3]];
         selectedLabels.forEach(function(label) {
            if (label) {
                label.innerHTML += '*';
            }
        });




  // #78
  // try {
  //   const sidebarLinks = document.querySelector(".faq__toc");
  //   const listItems = sidebarLinks.querySelectorAll("li");
    
  //   for (let i = 0; i < listItems.length; i++) {
  //     listItems[i].querySelector("a").addEventListener("click", function(event) {
  //       updateSelectedLinks(event);
  //     });
  
  //     listItems[i].querySelector("a").addEventListener("keydown", function(event) {
  //       if (event.key === "Enter") {
  //         updateSelectedLinks(event);
  //       }
  //     });
  //   }
  
  //   function updateSelectedLinks(event) {
  //     const existingSelectedLink = sidebarLinks.querySelector("#selected-link");
  //     if (existingSelectedLink) {
  //       existingSelectedLink.remove();
  //     }
      
  //     const span = document.createElement("span");
  //     span.className = "sr-only";
  //     span.id = "selected-link";
  //     span.textContent = "Selected";
      
  //     event.currentTarget.appendChild(span);
  //     adjustActiveClass(event);
  //   }
  
  //   function adjustActiveClass(event) {    
  //     const activeElement = document.querySelector(".is-active");
  //     const adaActiveElement = document.querySelector(".ada-is-active");
  //     if(adaActiveElement) {
  //       adaActiveElement.classList.remove("ada-is-active");
  //       adaActiveElement.style.borderBottom = "none";
  //       adaActiveElement.style.background = "none";
  //     } else if (activeElement) {
  //       activeElement.classList.remove("is-active");
  //       activeElement.style.borderBottom = "none";
  //       activeElement.style.background = "none";
  //     } 
    
  //     const targetLink = event.currentTarget || event.target;
  //     if (targetLink) {
  //       targetLink.classList.add("ada-is-active");
  //       targetLink.style.borderBottom = "1px solid #000";
  //     } else {
  //       console.error("targetLink is undefined or null", event);
  //     }
  //   }
  // } catch (e) {
  //   console.warn(e);
  // }


    var ids = [
        'block-category_WicGiP',
        'block-category_RztHgi',
        'block-category_NfGn4j',
        'block-category_dmK98X',
        'block-category_VYRK6G'
    ];
    
    var selector = ids.map(id => `h2#${id}`).join(', ');    
    var targetH2s = document.querySelectorAll(selector);

    
    targetH2s.forEach(function(targetH2) {        
        var section = document.createElement('section');
        section.id = targetH2.id;
        section.tabIndex = 0;         
        var nextElement = targetH2.nextElementSibling;
        while (nextElement && nextElement.tagName !== 'H2') {
            var nextSibling = nextElement.nextElementSibling;
            section.appendChild(nextElement);
            nextElement = nextSibling;
        }        
        targetH2.parentNode.insertBefore(section, targetH2.nextSibling);
    });

    
    document.querySelectorAll('.faq ul a[href]').forEach(function(anchor) {
        var hrefValue = anchor.getAttribute('href');
        var targetId = hrefValue.substring(1);

        anchor.addEventListener('click', function(e) {
            if (e.type === 'click' || e.key === 'Enter') {
                e.preventDefault();
                var targetSection = document.querySelector('.faq__content h2#' + targetId);
                if (targetSection) {
                    targetSection.setAttribute('tabindex', '0');
                    targetSection.focus();
                }
            }
        });

        anchor.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                var targetSection = document.querySelector('.faq__content h2#' + targetId);
                if (targetSection) {
                    targetSection.setAttribute('tabindex', '0');
                    targetSection.focus();
                }
            }
        });

    // #81+, un-requested functionality
    /*document.querySelectorAll('.faq__content section#' + targetId).forEach((section) => {    
    section.querySelectorAll('details').forEach((detailsElement, index, detailsElements) => {
        const summaryElement = detailsElement.querySelector('summary');        
        if (index === detailsElements.length - 1) {
            summaryElement.addEventListener('keydown', function(e) {
                if (e.key === 'Tab' && !e.shiftKey) {
                    e.preventDefault();
                    const targetAnchor = document.querySelector("a[href='" + hrefValue + "']");
                    if (targetAnchor) {
                        targetAnchor.focus();
                    }
                }
            });
        }        
        if (index === 0) {
            summaryElement.addEventListener('keydown', function(e) {
                if (e.key === 'Tab' && e.shiftKey) {
                    e.preventDefault();
                    const targetAnchor = document.querySelector("a[href='" + hrefValue + "']");
                    if (targetAnchor) {
                        targetAnchor.focus();
                    }
                }
            });
        }
    });
});*/
    });
    
    document.querySelectorAll('.faq__content section summary').forEach(summary => {
        summary.setAttribute('tabindex', '0');
    });

// aeye: no longer applies to current structure  (needed for ADA Copy of Prestige 10.0.2 structure)
   // var summaries = document.querySelectorAll('#block-category_VYRK6G summary');
   //  if (summaries.length > 1) {
   //      var secondSummary = summaries[1];        
   //      secondSummary.addEventListener('keydown', function(e) {
   //          if (e.key === 'Tab' && !e.shiftKey) {
   //              e.preventDefault();
   //              var targetInput = document.querySelector("input#input--sections--17112099815578__newsletter_PVnnHe--contactemail");
   //              if (targetInput) {
   //                  targetInput.focus();
   //              }
   //          }
   //      });
   //  }
  

function replaceTextWithTags() {    
    const paragraphs = document.querySelectorAll('.prose p');    
    paragraphs.forEach(p => {
        const strong = p.querySelector('strong');
        if (strong) {
            switch (strong.textContent.trim().toLowerCase()) {
                // case 'product dimensions:':
                //     const h2Dimension = document.createElement('h2');
                //     const strongDetail = document.createElement('strong');
                //     strongDetail.textContent = 'Product Dimension'; // Capitalized for consistency
                //     h2Dimension.appendChild(strongDetail);
                //     p.parentNode.replaceChild(h2Dimension, p); // Replaces the <p> with <h2>
                //     break;

                case 'product details':
                    const h2Details = document.createElement('h2');
                    const strongDetails = document.createElement('strong');
                    strongDetails.textContent = 'Product Details:'; 
                    h2Details.appendChild(strongDetails);
                    p.parentNode.replaceChild(h2Details, p); 
                    break;

                case 'flat sheet':
                    const h3FlatSheet = document.createElement('h3');
                    const h3strongDetails = document.createElement('strong');
                    h3strongDetails.textContent = 'Flat Sheet'; 
                    h3FlatSheet.appendChild(h3strongDetails);
                    p.parentNode.replaceChild(h3FlatSheet, p); 
                    break;

                case 'fitted sheet':
                    const h3FittedSheet = document.createElement('h3');
                    const h3strongDetail = document.createElement('strong');
                    h3FittedSheet.className = 'kl_reviews__review__title';
                    h3strongDetail.textContent = 'Fitted Sheet';
                    h3FittedSheet.appendChild(h3strongDetail); 
                    p.parentNode.replaceChild(h3FittedSheet, p); 
                    break;
                case 'pillowcases':
                    const pillowCases = document.createElement('h3');
                    const strongPillowcases = document.createElement('strong');                    
                    strongPillowcases.textContent = 'pillowcases';
                    pillowCases.appendChild(strongPillowcases); 
                    p.parentNode.replaceChild(pillowCases, p); 
                    break;
                case 'care instructions':
                    const careInstructions = document.createElement('h3');
                    const strongCareInstructions = document.createElement('strong');                    
                    strongCareInstructions.textContent = 'care instructions:';
                    careInstructions.appendChild(strongCareInstructions); 
                    p.parentNode.replaceChild(careInstructions, p); 
                    break;
            }
        }
    });
}
replaceTextWithTags();

document.addEventListener('click', function(event) {    
    if (event.target.matches("a.pagination__link")) {
        const link = event.target;
        const url = new URL(link.href);
        const pageValue = url.searchParams.get("page");
        setTimeout(function() {
          if (pageValue) {         
              event.preventDefault();    
              window.history.pushState(null, "", url);
              updateTitle(); 
          }
        }, 100);
    }
});

window.addEventListener('popstate', function() {
    updateTitle();
});

function updateTitle() {
    const originalTitle = document.title;
    const url = new URL(window.location.href);
    const pageValue = url.searchParams.get("page");
    if (pageValue) {
        const titlePrefix = originalTitle.split(" | ")[0];
        const titlePrefixs = titlePrefix.split(" - ")[0];
        //console.log(titlePrefixs);
        const newTitle = `${titlePrefixs} - Page ${pageValue} | down etc`;
        document.title = newTitle;
    }
}
window.addEventListener('load', updateTitle);



document.querySelectorAll('button.before-after__cursor').forEach(button => {    
    const span = document.createElement('span');
    span.classList.add('sr-only'); 
    button.appendChild(span);    
    button.addEventListener('focus', () => {
        span.textContent = 'selected'; 
    });    
    button.addEventListener('blur', () => {
        span.textContent = 'deselected'; 
    });
});

// aeye rewrite 
  setTimeout(function() {
  function createLabel(inputElem, labelText) {
    const inputId = document.querySelector(inputElem).id;
    const inputElement = document.getElementById(inputId);
      if (inputElement && !inputElement.previousElementSibling) {
          const label = document.createElement('label');
          const innerHtmlCondition = inputElement.hasAttribute('aria-required');
          label.setAttribute('for', inputId);
          label.classList.add('sr-only'); // Apply 'sr-only' class
          label.innerHTML = innerHtmlCondition ? `${labelText} <span>*</span>` : label.innerHTML = labelText;
          inputElement.parentNode.insertBefore(label, inputElement);
      }
      if (inputElement && inputElement.previousElementSibling ) {
        if (inputElement.previousElementSibling.tagName !== 'LABEL') {
          const label = document.createElement('label');
          const innerHtmlCondition = inputElement.hasAttribute('aria-required');
          label.setAttribute('for', inputId);
          label.classList.add('sr-only'); // Apply 'sr-only' class
          label.innerHTML = innerHtmlCondition ? `${labelText} <span>*</span>` : label.innerHTML = labelText;
          inputElement.parentNode.insertBefore(label, inputElement);
        } 
      }
  }
  createLabel('[id^="first_name_"]', 'First Name');
  createLabel('[id^="last_name_"]', 'Last Name');
  createLabel('[id^="email_"]', 'Email Address');
}, 10000); 
  
// aeye rewrite above: ID issue
//  setTimeout(function() {
// function createLabel(inputId, labelText) {
//     const inputElement = document.getElementById(inputId);
//     if (inputElement) {
//         const label = document.createElement('label');
//         label.setAttribute('for', inputId);
//         label.classList.add('sr-only'); // Apply 'sr-only' class
//         label.innerHTML = `${labelText} <span>*</span>`;
//         inputElement.parentNode.insertBefore(label, inputElement);
//     }
// }
// createLabel('first_name_109954940', 'First Name');
// createLabel('last_name_109954941', 'Last Name');
// createLabel('email_109954942', 'Email Address');
//   }, 10000); 



document.querySelectorAll('button.collection-toolbar__button').forEach(function(button) {
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-haspopup', 'true');
});


  try{
    var button_link = document.querySelector(".variant-picker__option button.link");
    document.querySelector(".prose.size-chart-page img").setAttribute("alt","Sheet Size Guide");
    document.addEventListener("click", function(event) {    
        if (button_link || event.target !== button_link) {        
            setTimeout(function() {
                button_link.removeAttribute("aria-expanded");
            }, 10);
        }
    });
  } catch(e){
    //console.warn(e)
  }


  let blogLinks = document.querySelectorAll(".blog-post-card")
  for(i=0;i<blogLinks.length;i++){
    let headerText = blogLinks[i].querySelector(".blog-post-card__title");
    headerText.setAttribute("role", "heading");
    headerText.setAttribute("aria-level", "2")
  }

});



// document.addEventListener('DOMContentLoaded', function() {
//     // Function to update 'aria-haspopup' based on 'aria-expanded'
//     function updateAriaHaspopup(button) {
//         const ariaExpanded = button.getAttribute('aria-expanded');
//         if (ariaExpanded === 'true') {
//             button.setAttribute('aria-haspopup', 'true213');
//         } else {
//             button.setAttribute('aria-haspopup', 'false213');
//         }
//     }

//     // Initial update on page load
//     document.querySelectorAll('button.collection-toolbar__button').forEach(function(button) {
//         updateAriaHaspopup(button);
//     });

//     // Add click event listener to update 'aria-haspopup' on button click
//     document.querySelectorAll('button.collection-toolbar__button').forEach(function(button) {
//         button.addEventListener('click', function() {
//             alert(1);
//             // const currentExpanded = button.getAttribute('aria-expanded') === 'true';
//             // button.setAttribute('aria-expanded', !currentExpanded ? 'true' : 'false');
//             // updateAriaHaspopup(button);
            
//         });
//     });
// });

// document.addEventListener('DOMContentLoaded', () => {
//   // custom-gift.js
//   const GIFT_ID     = 45691377549466;
//   const STORAGE_KEY = `giftRemoved_${GIFT_ID}`;
//   let giftRemoved   = localStorage.getItem(STORAGE_KEY) === 'true';
//   let prevCart      = null;

//   // Clears the “manual removal” flag so the gift can be re‑added
//   function clearRemovalFlag() {
//     giftRemoved = false;
//     localStorage.removeItem(STORAGE_KEY);
//   }

//   // Helper to fetch the full cart object
//   async function fetchCart() {
//     const res = await fetch(`${Shopify.routes.root}cart.js`);
//     return await res.json();
//   }

//   // Figure out your cart‑drawer section ID for patching theme.js expectations
//   const drawer          = document.querySelector('cart-drawer');
//   const sectionWrapper  = drawer?.closest('[id^="shopify-section-"]');
//   const SECTION_ID      = sectionWrapper?.id.replace('shopify-section-','');

//   // 1) CAPTURE-PHASE PATCH: ensure every cart:change has a `.sections` object
//   document.addEventListener('cart:change', evt => {
//     const cart = evt.detail?.cart;
//     if (cart && SECTION_ID && cart.sections == null) {
//       cart.sections = { [SECTION_ID]: '' };
//     }
//   }, { capture: true });

//   // 2) DETECTION: flip the removal flag if they manually delete the gift
//   document.addEventListener('cart:change', evt => {
//     const cart = evt.detail?.cart;
//     if (!cart || !Array.isArray(cart.items)) {
//       prevCart = cart;
//       return;
//     }
//     if (prevCart && Array.isArray(prevCart.items)) {
//       const hadGift = prevCart.items.some(i => i.variant_id === GIFT_ID);
//       const hasGift = cart.items.some(i => i.variant_id === GIFT_ID);
//       if (hadGift && !hasGift) {
//         giftRemoved = true;
//         localStorage.setItem(STORAGE_KEY, 'true');
//       }
//     }
//     prevCart = cart;
//   });

//   // 3) ADDITION: only on explicit cart updates (variant:add or pageshow)
//   async function addGiftIfNeeded(cart) {
//     if (giftRemoved) return;
//     if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;
//     if (cart.items.some(i => i.variant_id === GIFT_ID)) return;

//     // Add the gift line item
//     await fetch(`${Shopify.routes.root}cart/add.js`, {
//       method:  'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body:    JSON.stringify({ id: GIFT_ID, quantity: 1 })
//     });

//     // Fetch the full cart so `.items` & `.sections` exist
//     const fullCart = await fetchCart();

//     // Let theme.js and other listeners refresh properly
//     document.dispatchEvent(new CustomEvent('cart:change', {
//       bubbles: true,
//       detail:  { cart: fullCart }
//     }));
//     document.dispatchEvent(new CustomEvent('cart:refresh', {
//       bubbles: true
//     }));
//   }

//   // 4) ON VARIANT ADD: clear the flag, then re‑attempt gift add
//   document.addEventListener('variant:add', async evt => {
//     clearRemovalFlag();
//     const cart = evt.detail?.cart ?? await fetchCart();
//     await addGiftIfNeeded(cart);
//   });

//   // 5) ON BACK/FORWARD CACHE: same behavior
//   window.addEventListener('pageshow', async evt => {
//     if (evt.persisted) {
//       clearRemovalFlag();
//       const cart = await fetchCart();
//       await addGiftIfNeeded(cart);
//     }
//   });

//   // 6) INITIALIZE prevCart so removals detect correctly
//   (async () => {
//     prevCart = await fetchCart();
//   })();
// });






